import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { configResolver } from './resolvers/config.resolver';
import { environment } from 'src/environments/environment';

const routes: Routes = [
  {
    path: 'help',
    loadChildren: () =>
      import('@modules/help/help.module').then((m) => m.HelpModule),
  },
  {
    path: '',
    resolve: {
      platformConfig: configResolver,
    },
    children: [
      {
        path: 'external',
        loadChildren: () =>
          import('@modules/external/external.module').then(
            (m) => m.ExternalModule
          ),
      },
      {
        path: 'events',
        loadChildren: () =>
          import('@modules/events/events.module').then(
            (m) => m.EventsModule
          ),
      },
      {
        path: 'auth',
        loadChildren: () =>
          import('@modules/auth/auth.module').then((m) => m.AuthModule),
      },
      {
        path: 'account',
        loadChildren: () =>
          import('@containers/account/account.module').then(
            (m) => m.AccountModule
          ),
      },
      {
        path: 'content/:shortCode',
        loadChildren: () =>
          import('@modules/static-content/static-content.module').then(
            (m) => m.StaticContentModule
          ),
      },
      {
        path: 'faqs',
        loadChildren: () =>
          import('@modules/faqs/faqs.module').then(
            (m) => m.FaqsModule
          ),
      },
      {
        path: ':eventSlug',
        loadChildren: () =>
          import('@containers/event/event.module').then((m) => m.EventModule),
      },
      {
        path: '**',
        redirectTo: 'external',
        pathMatch: 'full'
      },
    ],
  },
  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'top',
      anchorScrolling: 'enabled',
      initialNavigation: 'enabledBlocking',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
